import { inject, injectable } from 'inversify'
import { SERVICE_TYPES } from '@/core/container/types'
import type DateTimeService from '@/services/dateTimeService'
import type { MessageSendRepeatFormScheme } from '@/services/domain/messages/types'
import type { CurrentUserInterface } from '@/services/domain/user/types'

@injectable()
export default class ComposeScheduledInitFormData {
  constructor(
    @inject(SERVICE_TYPES.DateTimeService) protected readonly dateTimeService: DateTimeService,
    @inject(SERVICE_TYPES.UserService) protected readonly userService: CurrentUserInterface,
  ) {}

  public getMessageSendRepeatInitFormData(): MessageSendRepeatFormScheme {
    return {
      type: 'none',
      end: {
        type: 'never',
        smsSessions: 1,
        date: this.getInitialEndDate(),
      },
      hourly: {
        count: 1,
      },
      daily: {
        count: 1,
      },
      weekly: {
        count: 1,
        days: [],
      },
      monthly: {
        count: 1,
        repeat: 'month-day',
        monthDay: '1',
        firstLastDay: 'First',
        weekDay: 'Sunday',
      },
      yearly: {
        count: 1,
        type: 'year-day',
        month: 'January',
        monthDay: '1',
        firstLastDay: 'First',
        weekDay: 'Sunday',
        dayOfMonth: 'January',
      },
    }
  }

  protected getInitialEndDate(): string {
    const timezone = this.userService.getCurrentTimezone()?.timezone
    const zonedNow = this.dateTimeService.utcToZonedTime(this.dateTimeService.now(), timezone)
    const tomorrow = this.dateTimeService.startOfDay(this.dateTimeService.addDays(zonedNow, 1))

    return this.dateTimeService.toISO(this.dateTimeService.zonedTimeToUtc(tomorrow, timezone))
  }
}
